import Rete from 'rete';

import VueConditionalNumControl from '../../components/commons/VueConditionalNumControl';


export default class ConditionalNumControl extends Rete.Control {

	constructor(emitter, key, readonly) {
		super(key);
		this.component = VueConditionalNumControl;
		this.props = { emitter, ikey: key, readonly };
	}

	setValue(val) {
		this.vueContext.value = val;
	}

	setVisibility(val) {
		this.vueContext.visibility = val;
	}

	getValue() {
		return this.vueContext.value;
	}
}
